import { Box, TextField } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import CarbonCreditingProgrammeSelect from "./CarbonCreditingProgrammeSelect";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../../types";
import SingleSelect from "../../../../common/SingleSelect";
import { assetTypeOptions } from "../../../utils";

function ProgrammeInfoContainer() {
  const context = useFormikContext<AddSolutionFormValues>();

  return (
    <Box data-testid="programme-info-section-collapsible">
      <SectionCollapsible label="Programme Info">
        <Box
          sx={{
            paddingBottom: 2,
          }}
        >
          <SingleSelect
            name={"asset-type"}
            label={"Asset Type (Credit Type)"}
            options={assetTypeOptions}
            fieldPath={"programme-info.asset-type"}
          />
        </Box>
        <Box
          sx={{
            paddingBottom: 2,
          }}
        >
          <CarbonCreditingProgrammeSelect />
        </Box>
        <TextField
          id="solution-programme-info-carbon-accounting-methodology"
          label="Carbon Accounting Methodology"
          variant="standard"
          fullWidth
          sx={{ paddingBottom: 2 }}
          autoComplete="disabled"
          onChange={(event) =>
            context.setFieldValue(
              "programme-info.carbon-accounting-methodology",
              (event.target as HTMLInputElement).value,
            )
          }
          value={
            context.values["programme-info"]["carbon-accounting-methodology"]
          }
        />
        <TextField
          id="solution-programme-info-description-document"
          label="Project Description Document Link"
          variant="standard"
          fullWidth
          autoComplete="disabled"
          onChange={(event) =>
            context.setFieldValue(
              "programme-info.description-document",
              (event.target as HTMLInputElement).value,
            )
          }
          value={context.values["programme-info"]["description-document"]}
          error={Boolean(
            context.errors["programme-info"]?.["description-document"],
          )}
          helperText={
            context.errors["programme-info"]?.["description-document"]
          }
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ProgrammeInfoContainer;
